import React, { useState, useEffect } from 'react';
import Post from '../../../../utils/Post';

const ContenedorSubmenu = (p) => {
    const submenu = p.submenu;


    const eliminarSubmenu = async () => {
        let resp = await Post('secure/relaciones/delete', { relaciones: [submenu.relacion_id] }, 'POST', p.setloader);
        p.refresh();
    }
    return (
        <div className='bw-800 round-s bg-black2 p-2 text-white mb-2 mt-2' >
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='w-100 text-bold text-l text-start'>
                    <div className='row justify-content-between w-100 m-0 p-0'>
                        <div className='bw-400 text-start text-s'>
                            <span className={`text-300 text-s me-3`}>Sección</span>{submenu.submenu_nombre}
                        </div>
                        <div className='bw-200 text-end contenedor'>
                            <button className='btn btn-danger btn-sm m-0 pt-0 pb-0 round-xxl shadow text-bold' type='button' onClick={eliminarSubmenu}>Eliminar sección</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContenedorSubmenu;